<!--
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-04-15 15:17:17
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-20 10:33:26
-->
<template>
  <div :class="['app-page-wrapper', `page-${theme} crmc-basic-app`]">
    <a-config-provider :locale="locale" :auto-insert-space-in-button="false">
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, watch } from 'vue'
import { useStore } from 'vuex'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default defineComponent({
  name: 'App',
  setup() {
    const store = useStore()
    const theme = computed(() => store.getters.theme)

    // 初始化 查询系统配置
    store.dispatch('app/checkSystemSetting')

    window.addEventListener(
      'message',
      (e) => {
        let data = e.data

        if (typeof data !== 'string') {
          return
        }

        try {
          data = JSON.parse(data)
          if (data.type === 'validatePluginInstall') {
            store.dispatch('app/setPluginInstallStatus', true)
          }
        } catch (error) {
          console.log('on message err', error)
        }
      },
      false
    )

    // 监听页面页签icon变化
    watch(
      () => store.state.app.systemSetting.systemPicture,
      (val) => {
        const link: HTMLLinkElement = document.querySelector('.page-link-icon')
        link.href = val
      }
    )

    return {
      theme
    }
  },
  data() {
    return {
      locale: zhCN
    }
  }
})
</script>

<style lang="less">
@import './styles/base.less';
@import './styles/common.less';
@import './styles/resetcomp.less';
// @font-face {
//   font-family: 'NotoSansHans';
//   src: url('./assets/fonts/NotoSansHans/NotoSansHans-Regular.otf');
//   font-weight: normal;
//   font-style: normal;
// }

@font-face {
  font-family: 'Barlow-medium';
  src: url('./assets/fonts/Barlow-Medium.ttf');
  font-weight: normal;
  font-style: normal;
}

.font-barlow-medium {
  font-family: 'Barlow-medium' !important;
  letter-spacing: 1px;
}

#app {
  font-family: NotoSansHans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  min-width: 1300px;
}

.app-page-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
